function getWishlist(){
  return JSON.parse(localStorage.getItem("wishlist")) || [];
}

function saveWishlist(data){
  localStorage.setItem("wishlist", JSON.stringify(data));
  updateWishlistCount();
}

function updateWishlistCount(){

  let wishlist = getWishlist();

  document.querySelectorAll(".wishlist-count").forEach(el=>{

    if(wishlist.length > 0){

      el.textContent = wishlist.length;
      el.classList.add("show");

    }else{

      el.classList.remove("show");

    }

  });

}

document.addEventListener("DOMContentLoaded",function(){

  updateWishlistCount();

document.querySelectorAll(".wishlist-icon-btn").forEach(btn=>{

 let id = btn.dataset.productId;

 let wishlist = getWishlist();

 if(wishlist.find(p => p.id === id)){
   btn.classList.add("active");
 }

 btn.addEventListener("click",function(){

   let wishlist = getWishlist();

   let product = {
     id: this.dataset.productId,
     title: this.dataset.productTitle,
     image: this.dataset.productImage,
     url: this.dataset.productUrl,
     price: this.dataset.productPrice,
     variant: this.dataset.productVariant
   };

   let exists = wishlist.find(p => p.id === product.id);

   if(exists){

     wishlist = wishlist.filter(p => p.id !== product.id);

     this.classList.remove("active");

   }else{

     wishlist.push(product);

     this.classList.add("active");

   }

   saveWishlist(wishlist);

 });

});

});



/* wishlist page render */

function renderWishlist(){

  let container = document.querySelector(".wishlist-products");

  if(!container) return;

  let wishlist = getWishlist();

  if(wishlist.length === 0){

    container.innerHTML = "<p>Wishlist is empty</p>";
    return;

  }

  container.innerHTML = wishlist.map(product => `

  <div class="wishlist-item">
  
    <div class="wishlist-image">

      <button class="remove-wishlist" data-id="${product.id}">
        ×
      </button>
    <a href="${product.url}">
      <img src="${product.image}" alt="${product.title}">
    </a>
    </div>
 <a href="${product.url}">
    <div class="wishlist-title-row">
  
      <div class="wishlist-title">
      
          ${product.title}
        
      </div>

     

    </div>

    <div class="wishlist-price">
      ${product.price || ""}
    </div>
  </a>
  </div>

  `).join("");

}



document.addEventListener("click",function(e){

  if(e.target.classList.contains("remove-wishlist")){

    let id = e.target.dataset.id;

    let wishlist = getWishlist().filter(p => p.id !== id);

    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    updateWishlistCount();

    renderWishlist();

  }

});


document.addEventListener("DOMContentLoaded",renderWishlist);





document.addEventListener("DOMContentLoaded", function () {

  const details = document.querySelectorAll('.collapsible-content details');

  details.forEach((targetDetail) => {

    targetDetail.addEventListener("toggle", () => {

      if (targetDetail.open) {

        details.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
          }
        });

      }

    });

  });

});
